import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Leads from "./components/Leads";
import Contacts from "./components/Contacts";
import Deals from "./components/Deals";
import Accounts from "./components/Accounts";
import Reports from "./components/Reports";
import Support from "./components/Support";
import CustomerSupport from "./components/CustomerSupport";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/toaster";
import UserManagement from './components/UserManagement'
import Synchronizing from "./components/Synchronizing";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/" >
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user_manageMent" element={<UserManagement/>} />
            <Route path="/leads" element={<Leads />} />
             <Route path="/integration" element={<Synchronizing />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/support" element={<Support />} />
            <Route path="/customer-support" element={<CustomerSupport />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;